export default __webpack_public_path__ + "static/media/AcceleronsGallery_26.ab8673b2.JPG";